import React from "react";
import { fDateTime, fDateMonth } from "../../../Utils/Date_formate";
import { Link } from "react-router-dom";

const DashboardCards = ({ monthexpiry }) => {
  const role = localStorage.getItem("Role")?.toLowerCase();

  const currentMonthYear = new Date().toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });

  const cardsData = [
    {
      link: `/${role}/planexpirymonth`,
      bgClass: "bg-gradient-moonlit",
      value1:
        monthexpiry?.monthexpiry?.length > 0
          ? monthexpiry?.monthexpiry?.some(
              (item) => fDateMonth(item?.month) === currentMonthYear
            )
            ? monthexpiry?.monthexpiry.reduce((acc, item) => {
                return fDateMonth(item?.month) === currentMonthYear
                  ? acc + (item.noofclient || 0)
                  : acc;
              }, 0)
            : 0
          : 0,
      label: "Current Month Active License",
      icon: "bx bxs-id-card",
      progress: 55,
    },
    {
      link: `/${role}/client`,
      bgClass: "bg-gradient-deepblue",
      value1: monthexpiry?.data?.clientCountTotal,
      label: "Total Clients",
      icon: "bx bxs-group",
      progress: 55,
    },
    {
      link: `/${role}/client`,
      state: { clientStatus: 1 },
      bgClass: "bg-gradient-ohhappiness",
      value1: monthexpiry?.data?.clientCountActive,
      label: "Total Active Clients",
      icon: "bx bxs-user-check",
      progress: 55,
    },
    {
      link: `/${role}/client`,
      state: { clientStatus: 0 },
      bgClass: "bg-gradient-ibiza",
      value1:
        monthexpiry?.data.clientCountTotal -
        monthexpiry?.data.clientCountActive,
      label: "Total Deactive Clients",
      icon: "bx bxs-user-minus",
      progress: 55,
    },
    {
      link: `/${role}/signal`,
      state: { clientStatus: "todayopensignal" },
      bgClass: "bg-gradient-moonlit",
      value1: monthexpiry?.data?.todayOpenSignal,
      label: "Today's Open Signal",
      icon: "bx bx-wifi",
      progress: 55,
    },
    {
      link: `/${role}/closesignal`,
      state: { clientStatus: "todayclosesignal" },
      bgClass: "bg-gradient-ibiza",
      value1: monthexpiry?.data?.todayCloseSignal,
      label: "Today's Close Signal",
      icon: "bx bx-wifi-off",
      progress: 55,
    },
    {
      link: `/${role}/signal`,
      bgClass: "bg-gradient-ohhappiness",
      value1: monthexpiry?.data?.OpensignalCountTotal,
      label: "Total Open Signals",
      icon: "bx bx-broadcast",
      progress: 55,
    },
    {
      link: `/${role}/closesignal`,
      bgClass: "bg-gradient-deepblue",
      value1: monthexpiry?.data?.CloseSignalCountTotal,
      label: "Total Close Signals",
      icon: "bx bx-no-signal",
      progress: 55,
    },
    {
      link: `/${role}/client`,
      state: { clientStatus: "active" },
      bgClass: "bg-gradient-deepblue",
      value1: monthexpiry?.data?.activePlanclient,
      label: "Total Plan Active Clients",
      icon: "bx bx-signal-5",
      progress: 55,
    },
    {
      link: `/${role}/client`,
      state: { clientStatus: "expired" },
      bgClass: "bg-gradient-deepblue",
      value1: monthexpiry?.data?.inActivePlanclient,
      label: "Total Plan Expired ",
      icon: "bx bx-timer",
      progress: 55,
    },
    // {
    //   link: `/${role}/freeclient`,
    //   state: { clientStatus: "active" },
    //   bgClass: "bg-gradient-deepblue",
    //   value1: monthexpiry?.data?.activeFreetrial,
    //   label: "Total Active Free Clients",
    //   icon: "bx bx-user",
    //   progress: 55,
    // },
    // {
    //   link: `/${role}/freeclient`,
    //   state: { clientStatus: "expired" },
    //   bgClass: "bg-gradient-deepblue",
    //   value1: monthexpiry?.data?.inActiveFreetrial,
    //   label: "Total Inactive Free Clients",
    //   icon: "bx bx-user-x",
    //   progress: 55,
    // },
    {
      link: `/${role}/todayExpiry-data`,
      state: { clientStatus: 0 },
      bgClass: "bg-gradient-deepblue",
      value1: monthexpiry?.data?.counts?.["0"],
      label: "Today's Expiry Plan",
      icon: "bx bx-calendar-exclamation",
      progress: 55,
    },
    {
      link: `/${role}/yesterdayExpiry-data`,
      state: { clientStatus: -1 },
      bgClass: "bg-gradient-deepblue",
      value1: monthexpiry?.data?.counts?.["-1"],
      label: "Yesterday Expiry Plan",
      icon: "bx bx-calendar-minus",
      progress: 55,
    },
    {
      link: `/${role}/tomorrowExpiry-data`,
      state: { clientStatus: 1 },
      bgClass: "bg-gradient-deepblue",
      value1: monthexpiry?.data?.counts?.["1"],
      label: "Tomorrow Expiry plan",
      icon: "bx bx-calendar-event",
      progress: 55,
    },
    {
      link: `/${role}/CurrentMonth-freeTrial`,
      bgClass: "bg-gradient-deepblue",
      value1: monthexpiry?.data?.totalfreetrial,
      label: "Current Month Free Trial",
      icon: "bx bxs-gift",
      progress: 55,
    },
    {
      link: `/${role}/active-clients-date-wise`,
      bgClass: "bg-gradient-deepblue",
      // value1: monthexpiry?.data?.activeClientsDateWise || 0,
      label: "Active Clients Date Wise",
      icon: "bx bx-revision",
      progress: 55,
    },
    {
      link: `/${role}/active-clients-by-date-range`,
      bgClass: "bg-gradient-deepblue",
      // value1: monthexpiry?.data?.activeClientsDateWise || 0,
      label: "Active Clients By Date Range",
      icon: "bx bx-user-check",
      progress: 55,
    },
  ];

  return (
    <div className="row newbg dashboard-card">
      {cardsData?.map((card, index) => (
        <div className="col-md-3" key={index}>
          <div className={`card border-0 radius-10 mb-4 ${card.bgClass}`}>
            <Link to={card.link} state={card.state}>
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    <div className="dashboard-icon">
                      <i className={`bx ${card.icon} fs-3`} />
                    </div>
                    <h5 className="mb-0 primary-text ms-3">{card.value1}</h5>
                  </div>

                  <div className="ms-auto">
                    <span className="badge  ms-2">
                      <i className="bx bx-up-arrow-alt fs-5" />
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center mt-3">
                  <p className="mb-0 content-heading text-light">
                    {card.label}
                  </p>
                  <p className="mb-0 ms-auto text-light"></p>
                </div>
                <div
                  className="progress my-2 bg-opacity-25"
                  style={{ height: 4 }}
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${card.progress}%` }}
                    aria-valuenow={25}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardCards;
